import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

// *load ข้อมูลสถานที่
function* labQualityEvaluationLoadLocation(action) {
  const {
    data: { location_list, location_type, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/get-location`,
      { location_list, location_type },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationLoadLocation.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationLoadLocation.failure())
  }
}

// *load ข้อมูลวัตถุดิบ
function* labQualityEvaluationLoadRawMaterial(action) {
  const {
    data: { accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/get-material`,
      {},
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationLoadRawMaterial.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationLoadRawMaterial.failure())
  }
}

// *load table log ประเมินคุณภาพ
function* labQualityEvaluationLoadTableLog(action) {
  const {
    data: {
      page,
      pageSize,
      orderBy,
      orderType,
      location_visibility,
      filterObj,
      type,
      limit_export,
      file_value_pdf,
      quality_evaluation_by,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/log`,
      {
        page,
        pageSize,
        orderBy,
        orderType,
        location_visibility,
        filterObj,
        type,
        limit_export,
        file_value_pdf,
        quality_evaluation_by,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationLoadTableLog.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationLoadTableLog.failure())
  }
}

//  *load ข้อมูล form ประเมินคุณภาพ
function* labQualityEvaluationLoadRequestForm(action) {
  const {
    data: { material_id, quality_evaluation_by, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/request-form`,
      { material_id, quality_evaluation_by },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationLoadRequestForm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationLoadRequestForm.failure())
  }
}

// *load detail ประเมินคุณภาพ
function* labQualityEvaluationLoadDetail(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/detail`,
      { id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationLoadDetail.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationLoadDetail.failure())
  }
}

// *create form ประเมินคุณภาพ
function* labQualityEvaluationCreateForm(action) {
  const {
    data: { data_for_api, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/create`,
      {
        ...data_for_api,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationCreateForm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationCreateForm.failure())
  }
}

// *ลบข้อมูล form ประเมินคุณภาพ
function* labQualityEvaluationDeleteForm(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/delete`,
      { id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationDeleteForm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationDeleteForm.failure())
  }
}

// *calculate form ประเมินคุณภาพ
function* labQualityEvaluationCalculateForm(action) {
  const {
    data: { accessToken, ...payload },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/calculator-quality-control-results`,
      { ...payload },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationCalculateForm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationCalculateForm.failure())
  }
}

// *export 1 form ประเมินคุณภาพ
function* labQualityEvaluationExportOneForm(action) {
  const {
    data: { id, type, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/export`,
      { id, type },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationExportOneForm.success(res.data))

    // window.location.assign(`${res.data.data}`)
    window.open(`${res.data.data}`, '_blank')
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationExportOneForm.failure())
  }
}
// *export หลาย form ประเมินคุณภาพ
function* labQualityEvaluationExportMultipleForm(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/multiple-export`,
      { id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationExportMultipleForm.success(res.data))

    const sftpPath = res.data.data
    const downloadRes = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
      { sftp_path: sftpPath },
      { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
    )
    const ext = sftpPath.split('.').pop().toLowerCase()
    const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const blob = new Blob([downloadRes.data], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = sftpPath.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationExportMultipleForm.failure())
  }
}

// *load division
function* labQualityEvaluationLoadDivision(action) {
  const {
    data: {
      location_visibility,
      division_id,
      department_id,
      section_id,
      plant_id,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/load-division`,
      { location_visibility, division_id, department_id, section_id, plant_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationLoadDivision.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationLoadDivision.failure())
  }
}

// *load department
function* labQualityEvaluationLoadDepartment(action) {
  const {
    data: { location_visibility, division_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/load-department`,
      { location_visibility, division_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationLoadDepartment.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationLoadDepartment.failure())
  }
}

// *load section
function* labQualityEvaluationLoadSection(action) {
  const {
    data: { location_visibility, department_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/load-section`,
      { location_visibility, department_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationLoadSection.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationLoadSection.failure())
  }
}

// *load plant
function* labQualityEvaluationLoadPlant(action) {
  const {
    data: { location_visibility, section_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/load-plant`,
      { location_visibility, section_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationLoadPlant.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationLoadPlant.failure())
  }
}

// *load ข้อมูลสถานที่ต้นแหล่ง โรงงานสำหรับฟอร์มประเมินคุณภาพ
function* labQualityEvaluationLoadLocationForm(action) {
  const {
    data: { location_list, location_type, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/get-location`,
      { location_list, location_type },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationLoadLocationForm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationLoadLocationForm.failure())
  }
}

// *load ข้อมูล test center
function* labQualityEvaluationLoadTestCenter(action) {
  const {
    data: { location_visibility, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/load-test-center`,
      { location_visibility },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationLoadTestCenter.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationLoadTestCenter.failure())
  }
}

// *export excel
function* labQualityEvaluationExportExcel(action) {
  const {
    data: {
      page,
      pageSize,
      orderBy,
      orderType,
      location_visibility,
      filterObj,
      type,
      limit_export,
      file_value_pdf,
      quality_evaluation_by,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/log`,
      {
        page,
        pageSize,
        orderBy,
        orderType,
        location_visibility,
        filterObj,
        type,
        limit_export,
        file_value_pdf,
        quality_evaluation_by,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationExportExcel.success(res.data))
    const sftpPath = res.data.data
    const downloadRes = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
      { sftp_path: sftpPath },
      { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
    )
    const ext = sftpPath.split('.').pop().toLowerCase()
    const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const blob = new Blob([downloadRes.data], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = sftpPath.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationExportExcel.failure())
  }
}

// *edit form ประเมินคุณภาพ
function* labQualityEvaluationEditForm(action) {
  const {
    data: { data_for_api, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/update`,
      {
        ...data_for_api,
      },
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    )

    yield put(actions.labQualityEvaluationEditForm.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationEditForm.failure())
  }
}

// *get user can add
function* labQualityEvaluationGetUserCanAdd(action) {
  const {
    data: { company_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/get-user-can-add`,
      { company_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.labQualityEvaluationGetUserCanAdd.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.labQualityEvaluationGetUserCanAdd.failure())
  }
}

export default function* watchLabQualityEvaluation() {
  yield all([
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_LOCATION.REQUEST,
      labQualityEvaluationLoadLocation
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_RAW_MATERIAL.REQUEST,
      labQualityEvaluationLoadRawMaterial
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_TABLE_LOG.REQUEST,
      labQualityEvaluationLoadTableLog
    ),

    takeEvery(
      actions.LAB_QUALITY_EVALUATION_REQUEST_FORM.REQUEST,
      labQualityEvaluationLoadRequestForm
    ),

    takeEvery(
      actions.LAB_QUALITY_EVALUATION_DETAIL.REQUEST,
      labQualityEvaluationLoadDetail
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_CREATE.REQUEST,
      labQualityEvaluationCreateForm
    ),

    takeEvery(
      actions.LAB_QUALITY_EVALUATION_DELETE.REQUEST,
      labQualityEvaluationDeleteForm
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_CALCULATE.REQUEST,
      labQualityEvaluationCalculateForm
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_EXPORT_ONE_FORM.REQUEST,
      labQualityEvaluationExportOneForm
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_EXPORT_MULTIPLE_FORM.REQUEST,
      labQualityEvaluationExportMultipleForm
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_LOAD_DIVISION.REQUEST,
      labQualityEvaluationLoadDivision
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_LOAD_DEPARTMENT.REQUEST,
      labQualityEvaluationLoadDepartment
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_LOAD_SECTION.REQUEST,
      labQualityEvaluationLoadSection
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_LOAD_PLANT.REQUEST,
      labQualityEvaluationLoadPlant
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_LOAD_LOCATION_FORM.REQUEST,
      labQualityEvaluationLoadLocationForm
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_TEST_CENTER.REQUEST,
      labQualityEvaluationLoadTestCenter
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_EXPORT_EXCEL.REQUEST,
      labQualityEvaluationExportExcel
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_EDIT.REQUEST,
      labQualityEvaluationEditForm
    ),
    takeEvery(
      actions.LAB_QUALITY_EVALUATION_GET_USER_CAN_ADD.REQUEST,
      labQualityEvaluationGetUserCanAdd
    ),
  ])
}
export {
  labQualityEvaluationLoadLocation,
  labQualityEvaluationLoadRawMaterial,
  labQualityEvaluationLoadTableLog,
  labQualityEvaluationLoadRequestForm,
  labQualityEvaluationLoadDetail,
  labQualityEvaluationCreateForm,
  labQualityEvaluationDeleteForm,
  labQualityEvaluationCalculateForm,
  labQualityEvaluationExportOneForm,
  labQualityEvaluationExportMultipleForm,
  labQualityEvaluationLoadDivision,
  labQualityEvaluationLoadDepartment,
  labQualityEvaluationLoadSection,
  labQualityEvaluationLoadPlant,
  labQualityEvaluationLoadLocationForm,
  labQualityEvaluationLoadTestCenter,
  labQualityEvaluationExportExcel,
  labQualityEvaluationEditForm,
  labQualityEvaluationGetUserCanAdd,
}
